



import Layout from '@/packages/ae-layout';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import {Component} from 'vue-property-decorator';

Vue.use(VueClipboard as any);
Vue.use(Layout);
@Component({
  name: 'App'
})
export default class App extends Vue {
}
